<template>
  <div v-if="visible" class="collabora-overlay" @click.self="close">
    <div class="collabora-panel">
      <div class="collabora-toolbar">
        <span>{{ title || 'Collabora Editor' }}</span>
        <button type="button" class="close-collabora-button" @click="close">Close</button>
      </div>
      <iframe
        v-if="editorUrl"
        class="collabora-iframe"
        :src="editorUrl"
        title="Collabora Office editor"
        allow="fullscreen; clipboard-write; clipboard-read"
      />
      <div v-else class="collabora-loading">
        Preparing editor...
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollaboraEditorModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editorUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Collabora Editor',
    },
  },
  emits: ['close'],
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          window.addEventListener('keydown', this.onKeydown);
        } else {
          window.removeEventListener('keydown', this.onKeydown);
        }
      },
    },
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    onKeydown(event) {
      if (event.key === 'Escape' && this.visible) {
        this.close();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

.collabora-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(15, 23, 42, 0.7);
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0.75rem;
}

.collabora-panel {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
}

.collabora-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f8fafc;
  color: #0f172a;
  font-weight: 600;
}

.close-collabora-button {
  background-color: $primary-color;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.45rem 0.75rem;
  cursor: pointer;
}

.close-collabora-button:hover {
  background-color: darken($primary-color, 10%);
}

.collabora-iframe {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  border: 0;
  background: white;
}

.collabora-loading {
  flex: 1;
  display: grid;
  place-items: center;
  color: #374151;
  font-size: 1.1rem;
}
</style>